export class AgentInfo {
  id: string;
  name: string;
  referralCode: string;
  constructor() {
    this.id = '';
    this.name = '';
    this.referralCode = '';
  }
}



// WEBPACK FOOTER //
// ./src/app/core/models/agent.ts